/* eslint-disable indent */
import { DetailsRow } from '../../../../components/Details/types';

export interface IRole {
    id?: string | number;
    label?: string;
    info?: string;
    name?: string;
    checked?: boolean;
    radioValue?: boolean;
}

export interface ICreateRole {
    id: string | number | number[] | null;
    name: string;
    description: string;
    roles: string[]
}
export interface IEditRole {
    id: string | number | number[] | null;
    name: string;
    description: string;
    roles: IRole | string[]
}
export interface IRolePros {
    title?: string;
    internal?: boolean,
    edit?: boolean,
    view?: boolean,
    detailsRows?: DetailsRow[],
    permissionCategories?: any,
    initialValues: any | ICreateRole | IEditRole,
    onSubmit?: any,
    handleDelete?: any;
}

export const internal_roles_titles = [
    'EKOME Admin',
    'EKOME Editor',
    'EKOME Publisher',
    'Film Office Editor',
    'Film Office Publisher',
    'Global Administrator',
    'INTERNAL_MICROSOFT'];

export const external_roles_titles = [
    'EXTERNAL_TAXISNET',
    'EXTERNAL_GOOGLE',
    'EXTERNAL_MICROSOFT',
    'EXTERNAL_FACEBOOK',
    'EXTERNAL_PASSWORD'];